import React, { useState } from 'react';
import { useInterval } from '../helpful-functions/use-interval.js';


interface TimerProps {
  startTime: number;
}
export function Timer(props: TimerProps) {
  const start: number = props.startTime;
  const [time, setTime] = useState(Date.now());

  useInterval(() => {
    setTime(update);
  }, 10);

  return (
    <h2 className='timer'>{FormatTime(time - start)}</h2>
  )
}



interface StaticProps {
  time: number
}
export function StaticTimer(props: StaticProps) {
  return (
    <h2 className='timer'>{FormatTime(props.time)}</h2>
  )
}



function update(n: number): number {
  return (Date.now());
}


export function FormatTime(milliseconds: number): string {
  let hours: number = Math.floor(milliseconds / 3600000);
  let minutes: number = Math.floor((milliseconds % 3600000) / 60000);
  let seconds: number = Math.floor((milliseconds % 60000) / 1000);
  let millis: number = Math.floor((milliseconds % 1000) / 10) / 100;
  return ((hours > 0? hours.toString() + ':' + (minutes >= 10? minutes.toString() : '0' + minutes.toString()) : minutes.toString()) + ":" 
     + (seconds >= 10 ? seconds.toString() : '0' + seconds.toString()) + millis.toFixed(2).substring(1));
}
